// src/VerificationIcon.tsx
import { jsx } from "react/jsx-runtime";
var VerificationIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "currentColor",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M2.952 5.482C1.849 7.392.947 8.975.947 9c0 .025.902 1.608 2.005 3.518l2.004 3.472h8.087l2.005-3.472c1.103-1.91 2.005-3.493 2.005-3.518 0-.025-.902-1.608-2.005-3.518L13.043 2.01H4.957L2.952 5.482m11.23.503c.944 1.634 1.714 2.994 1.71 3.024-.004.03-.776 1.39-1.717 3.022l-1.71 2.966h-6.93L3.84 12.058a268.604 268.604 0 0 1-1.722-3.009c-.023-.061.208-.478 1.677-3.022a382.466 382.466 0 0 1 1.733-2.99c.023-.029.743-.036 3.483-.03l3.454.008 1.717 2.97M9.739 8.462l-1.886 2.042-.064-.06c-.035-.033-.368-.39-.739-.794l-.675-.733-.105.086c-.058.048-.225.199-.372.336l-.267.25 1.1 1.191c.606.654 1.111 1.189 1.122 1.188A190.32 190.32 0 0 0 10.12 9.53l2.244-2.435-.354-.337a6.371 6.371 0 0 0-.371-.337c-.008-.001-.864.918-1.9 2.041",
        fillRule: "evenodd",
        stroke: "none"
      }
    )
  }
);
var VerificationIcon_default = VerificationIcon;

export {
  VerificationIcon_default
};
